import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PortfolioAnalytics from "../components/PortfolioAnalytics";

const Portfolio = () => {
    const { t } = useTranslation();
    return (
        <Box sx={{ maxWidth: 900, mx: "auto", mt: 4, mb: 4 }}>
            <Typography variant="h4" sx={{ mb: 3 }}>{t("portfolio.title", "My Portfolio")}</Typography>
            <PortfolioAnalytics />
        </Box>
    );
};

export default Portfolio; 